"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortArrayBasedOnOrder = void 0;
const sortArrayBasedOnOrder = (arr, order) => {
    return arr.sort((a, b) => {
        const aIndex = order.indexOf(a[0]);
        const bIndex = order.indexOf(b[0]);
        if (aIndex === -1 && bIndex === -1) {
            return 0;
        }
        else if (aIndex === -1) {
            return 1;
        }
        else if (bIndex === -1) {
            return -1;
        }
        return aIndex - bIndex;
    });
};
exports.sortArrayBasedOnOrder = sortArrayBasedOnOrder;
